import { FC, Fragment } from 'react';

import { GridColumn, HSpacingContainer, Skeleton, VSpacingContainer } from '@hh.ru/magritte-ui';

import styles from 'components/BalanceAndBonuses/History/History.module.less';

// eslint-disable-next-line no-restricted-properties
const createArray = (length: number) => Array.from({ length }).map((_, i) => i);

const RECORDS_COUNT = 6;

const HistorySkeleton: FC = () => (
    <GridColumn xs={4} s={4} m={7} l={6}>
        <div className={styles.wrapper}>
            <Skeleton loading width={116} height={19} borderRadius={4} />
            <HSpacingContainer default={12}>
                <Skeleton loading width={131} height={40} borderRadius={40} />
                <Skeleton loading width={96} height={40} borderRadius={40} />
            </HSpacingContainer>

            <VSpacingContainer default={24}>
                <div>
                    <Skeleton loading width={70} height={14} borderRadius={4} />
                </div>

                <VSpacingContainer default={24}>
                    {createArray(RECORDS_COUNT).map((index) => (
                        <Fragment key={index}>
                            <HSpacingContainer default={12}>
                                <Skeleton loading width={48} height={48} borderRadius={12} />
                                <div className={styles.skeletonRecordDescriptionWrapper}>
                                    <Skeleton loading width={229} height={14} borderRadius={4} />
                                    <Skeleton loading width={70} height={14} borderRadius={4} />
                                </div>
                                <div className={styles.skeletonRecordDescriptionWrapperRight}>
                                    <Skeleton loading width={70} height={14} borderRadius={4} />
                                    <Skeleton loading width={70} height={14} borderRadius={4} />
                                </div>
                            </HSpacingContainer>
                        </Fragment>
                    ))}
                </VSpacingContainer>
            </VSpacingContainer>
        </div>
    </GridColumn>
);

export default HistorySkeleton;
